import React from 'react'

function Icon() {
    return (
        <svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  
  >
    <rect width={32} height={32} rx={3} fill="#E6E6E6" />
    <mask
      id="a"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={4}
      y={4}
      width={32}
      height={32}
    >
      <path fill="#D9D9D9" d="M4 4h24v24H4z" />
    </mask>
    <g mask="url(#a)">
      <path
        d="M16 6.5a9.5 9.5 0 1 1 0 19 9.5 9.5 0 0 1 0-19m-3.162 5-.338 1.113h1.372l.712.005q1.002.037 1.506.518.33.313.46.77h-3.712L12.5 15.06h4.085a1.6 1.6 0 0 1-.212.527q-.264.402-.76.606-.498.2-1.204.199H12.6l.02.835 3.64 4.455h1.55v-.08l-3.36-4.117h.03q1.242 0 1.999-.402.76-.402 1.103-1.063.235-.452.31-.96h1.052l.338-1.154h-1.41a3 3 0 0 0-.32-.91 2.4 2.4 0 0 0-.235-.356l1.627.013.338-1.153z"
        fill="#1A1A1A"
      />
    </g>
  </svg>
    )
}
export default Icon